export default __webpack_public_path__ + "static/media/CliniMACS_Prodigy_System_brochure.3c6372df.pdf";